import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../provider/CommonContext";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner'
import { format, parseISO } from 'date-fns';
function OptionChains() {
    const { BaseURL } = useContext(URLstateContext);
    const [Optiondata, setOptiondata] = useState([])
    const [Optiondatacall, setOptiondatacall] = useState([]);
    const [type, settype] = useState('put');
    const [DateDrp, setDate] = useState([]);
    const [OptionDate, setOptionDate] = useState([]);
    const [Symbol, setSymbol] = useState('Nifty');
    let navigate = useNavigate();
    const [OptionSymbol, setOptionSymbol] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    const [valueschemename, setValueschemename] = useState([]);
    let getOptionChains, getOptionDate, getOptionSymbol, getOptionChainscall;

    useEffect(() => {
        setloadingshow(true)
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/opt/${Symbol}`)
            .then((response) => response.json())
            .then((dataOptionDate) => {
                getOptionDate = dataOptionDate.data;
                setOptionDate(getOptionDate);
                setloadingshow(false);
                var codename = getOptionDate[0].ExpiryDateText.split(' ').join('-');
                setValueschemename(codename.split(' ').join('-'))
                if (type === 'put') {
                    const getUrlOptionChains = BaseURL + "Optionschain";
                    fetch(`${getUrlOptionChains}/${Symbol}/${codename}/Y/-`)
                        .then((response) => response.json())
                        .then((dataOptionChains) => {
                            getOptionChains = dataOptionChains.data;
                            setOptiondata(getOptionChains);
                            setloadingshow(false)
                            // console.log(getOptionChains, "getOptionChains")
                        })
                        .catch((error) => {
                        });
                } else {
                    const getUrlOptionChains = BaseURL + "Optionschain";
                    fetch(`${getUrlOptionChains}/${Symbol}/${codename}/Y/-`)
                        .then((response) => response.json())
                        .then((dataOptionChainscall) => {
                            getOptionChainscall = dataOptionChainscall.data;
                            setOptiondatacall(getOptionChainscall);
                            setloadingshow(false)

                        })
                        .catch((error) => {
                        });

                }
            })
            .catch((error) => {
            });
    }, [type])

    const moreContent = () => {
        navigate("/Futures-And-Options/Option-Chain")
    }

    useEffect(() => {
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/opt/${Symbol}`)
            .then((response) => response.json())
            .then((dataOptionDate) => {
                getOptionDate = dataOptionDate.data;
                setOptionDate(getOptionDate);
                setloadingshow(false);
            })

        fetch(`${getUrldate}/sym/-`)
            .then((response) => response.json())
            .then((dataOptionSymbol) => {
                getOptionSymbol = dataOptionSymbol.data;
                setOptionSymbol(getOptionSymbol);
                var abc = getOptionSymbol;
            })
            .catch((error) => {
            });

        const getUrlOptionChains = BaseURL + "Optionschain";

        if (type === 'put') {
            fetch(`${getUrlOptionChains}/${Symbol}/${DateDrp}/Y/-`)
                .then((response) => response.json())
                .then((dataOptionChains) => {
                    getOptionChains = dataOptionChains.data;
                    setOptiondata(getOptionChains);
                    setloadingshow(false)
                    // console.log(getOptionChains, "getOptionChains")
                })
                .catch((error) => {
                });
        }
        else {
            fetch(`${getUrlOptionChains}/${Symbol}/${DateDrp}/Y/-`)
                .then((response) => response.json())
                .then((dataOptionChainscall) => {
                    getOptionChainscall = dataOptionChainscall.data;
                    setOptiondatacall(getOptionChainscall);
                    setloadingshow(false)

                })
                .catch((error) => {
                });

        }
    }, [type, Symbol, DateDrp])
    return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>Option Chains</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className=''>
                        <div className="dropdowndiv">
                            <div className='put-call-toggleChain '>
                                <button id="btnGain" value="put" className={(type === "put") ? "active" : ''} onClick={(event) => { settype(event.target.value); document.getElementById("select-date").selectedIndex = "0"; setDate('') }}>Put</button>
                                <button id="btnLoose" value="call" className={(type === "call") ? "active" : ''} onClick={(event) => { settype(event.target.value); document.getElementById("select-date").selectedIndex = "0"; setDate('') }}>Call</button>
                            </div>
                            <div className='put-option'>
                                <div className='put-call-selectChain'>
                                    
                                    {/* aria-label="Select Symbol" */}
                                    <select aria-label="Select Symbol" onChange={(event) => {setSymbol(event.target.value); document.getElementById("select-date").selectedIndex = "0"; setDate('')}}>
                                        <option>Select Symbol</option>
                                        {OptionSymbol && OptionSymbol.map(
                                            ({ symbol }) => (
                                                <option value={symbol.trim()}>{symbol.trim()}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className='put-call-selectIChain'>

                                    {/* aria-label="Select Expiry Date" */}
                                    <select aria-label="Select Expiry Date" id="select-date" onChange={(event) => setDate(event.target.value)}>
                                        <option value={(OptionDate[0] != null) ? OptionDate[0].ExpiryDateText : ''}>Select Expiry Date</option>
                                        {OptionDate && OptionDate.map(
                                            ({ ExpiryDateText }) => (
                                                <option value={ExpiryDateText.split(' ').join('-')} selected={valueschemename === ExpiryDateText.split(' ').join('-')}>{ExpiryDateText.split(' ').join('-')}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className='mf-table table-responsive gainer-table'>
                            <div className='newhigh-table table-responsive'>
                                <table className='table'>
                                    {(() => {
                                        if (type === "put") {
                                            return (
                                                <><thead>
                                                    <tr>
                                                        <th className='text-left'>Symbol</th>
                                                        <th className='text-right'>Expiry Date</th>
                                                        <th className='text-right'>Strike Price</th>
                                                        {/* <th className='text-right'>Best Buy(&#8377;)</th>
                                                        <th className='text-right'>Best Sell(&#8377;)</th> */}
                                                        <th className='text-right'>Last Price(&#8377;)</th>
                                                        <th className='text-right'>Change(&#8377;)</th>

                                                    </tr>
                                                </thead>
                                                {(Optiondata === null) ? <div className="errormsgComNew"><h3>No Data Found !!!</h3></div> : ''}
                                                    <tbody>
                                                        {(Optiondata != null) && Optiondata.map(
                                                            ({ strikeprice, PutPriceperChange, Putbbuyprice, Putbsellprice, PutLTP, symbol, expdate }) => (
                                                                <tr>
                                                                    <td className='text-left'>{symbol}</td>
                                                                    <td className='text-right'>{format(parseISO(expdate.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                                    <td className='text-right'>{strikeprice != null ? strikeprice : 0}</td>
                                                                    {/* <td className='text-right'>{Putbbuyprice != null ? Putbbuyprice : 0}</td>
                                                                    <td className='text-right'>{Putbsellprice != null ? Putbsellprice : 0}</td> */}
                                                                    <td className='text-right'>{PutLTP != null ? PutLTP : 0}</td>
                                                                    {/* <td className='text-right'>{PutPriceperChange != null ? PutPriceperChange.toFixed(2) : 0}</td> */}
                                                                    <td><p className={PutPriceperChange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {PutPriceperChange != null ? PutPriceperChange.toFixed(2) : 0} </p></td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else {
                                            return (
                                                <><thead>
                                                    <tr>
                                                        <th className='text-left'>Symbol</th>
                                                        <th className='text-right'>Expiry Date</th>
                                                        <th className='text-right'>Strike Price</th>
                                                        {/* <th className='text-right'>Best Buy(&#8377;)</th>
                                                        <th className='text-right'>Best Sell(&#8377;)</th> */}
                                                        <th className='text-right'>Last Price(&#8377;)</th>
                                                        <th className='text-right'>Change(&#8377;)</th>
                                                    </tr>
                                                </thead>
                                                {(Optiondatacall === null) ? <div className="errormsgComNew"><h3>No Data Found !!!</h3></div> : ''}
                                                    <tbody>
                                                        {(Optiondatacall != null) && Optiondatacall.map(
                                                            ({ strikeprice, CallPricePerChange, callbbuyprice, callbsellprice, CallLTP, symbol, expdate }) => (
                                                                <tr>
                                                                    <td className='text-left'>{symbol}</td>
                                                                    <td className='text-right'>{format(parseISO(expdate.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                                    <td className='text-right'>{strikeprice != null ? strikeprice : 0}</td>
                                                                    {/* <td className='text-right'>{callbbuyprice != null ? callbbuyprice : 0}</td>
                                                                    <td className='text-right'>{callbsellprice != null ? callbsellprice : 0}</td> */}
                                                                    <td className='text-right'>{CallLTP != null ? CallLTP : 0}</td>
                                                                    {/* <td className='text-right'>{CallPricePerChange != null ? CallPricePerChange.toFixed(2) : 0}</td> */}
                                                                    <td><p className={CallPricePerChange.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {CallPricePerChange != null ? CallPricePerChange.toFixed(2) : 0} </p></td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </>)
                                        }
                                        // }
                                    })()}
                                </table>
                            </div>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
}

export default OptionChains